<template>
    <span class="playercard">
        <div class="player-name">{{player.name}}</div>
        <span class="player-avg" @click.prevent="switchAvg()" :title="'Average ' + showAvg + 'Dart'">{{shownAvg}}</span>
        <a :href="'/players/' + player.id"><i class="far fa-address-card" title="Spieler Profil"></i></a>
        <span v-if="webcamnumber() > 0" class="webcam">
            <svg style="width:20px;height:20px;margin-top: -4px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,2A7,7 0 0,1 19,9A7,7 0 0,1 12,16A7,7 0 0,1 5,9A7,7 0 0,1 12,2M12,4A5,5 0 0,0 7,9A5,5 0 0,0 12,14A5,5 0 0,0 17,9A5,5 0 0,0 12,4M12,6A3,3 0 0,1 15,9A3,3 0 0,1 12,12A3,3 0 0,1 9,9A3,3 0 0,1 12,6M6,22A2,2 0 0,1 4,20C4,19.62 4.1,19.27 4.29,18.97L6.11,15.81C7.69,17.17 9.75,18 12,18C14.25,18 16.31,17.17 17.89,15.81L19.71,18.97C19.9,19.27 20,19.62 20,20A2,2 0 0,1 18,22H6Z" />
            </svg>
            <div class="webcamnumber" v-html="webcamnumber()"></div>
        </span>
        <span class="microphone" v-if="microphone()">
            <i class="fas fa-microphone"></i>
        </span>
    </span>
</template>

<script>
    export default {
        props: ['player', 'user'],

        data() {
            return {
                showAvg: 3,
                shownAvg: this.player.avg3,

                names: ["Superspieler", "Darts180", "TreffNix"]
            }
        },
        mounted() {
            this.showAvg = localStorage.getItem("PlayerCardAverage") ? parseInt(localStorage.getItem("PlayerCardAverage")) : 3;
            this.switchTo(this.showAvg);
            this.$root.$on("PlayerCardSwitchAverage", (avg) => this.switchTo(avg));
        },
        methods: {
            randomName() {
                return this.names[Math.floor(Math.random() * 3) + 0]
            },
            webcamnumber() {
                let number = 0;
                if (this.user.live != 0) number += 1;
                if (this.user.live2 != 0) number += 1;
                return number;
            },
            microphone() {
                return this.user && this.user.microphone
            },
            switchAvg() {
                if (this.showAvg == 3) this.switchTo(1);
                else this.switchTo(3);

                this.$root.$emit("PlayerCardSwitchAverage", this.showAvg);
                localStorage.setItem("PlayerCardAverage", this.showAvg);
            },
            switchTo(avg) {
                this.showAvg = avg;
                if (this.showAvg == 3) this.shownAvg = this.player.avg3;
                if (this.showAvg == 1) this.shownAvg = this.player.avg1;
            }
        }
    }
</script>
